module.exports = __webpack_public_path__ + "static/Odaseva-f9ad69bd5cf41783e3e9fead205b9abd.jpg";